import { Children } from "react";

import styles from "./menu.module.css"

export const Menu = ({ children }) => {
    const count = Children.count(children);
    return (
        <div
            className={styles.menu}
            style={{ gridTemplateColumns: `repeat(${count}, 1fr)` }}
        >
            {children}
        </div>
    )
}
